export default {
  setRoles (state, payload) {
    state.roles = payload
  },
  setPlans (state, payload) {
    state.plans = payload
  },
  setOrganizations (state, payload) {
    state.organizations = payload
  },
  setUserOrganization (state, payload) {
    state.userOrganization = payload
  },
  setSelectedOrganizationId (state, payload) {
    state.selectedOrganizationId = payload
  },
  setSelectedProjectId (state, payload) {
    state.selectedProjectId = payload
  },
  setProjectsDisplay (state, payload) {
    state.projectsDisplay = payload
  },
  setDisplayOwnProjects (state, payload) {
    state.displayOwnProjects = payload
  },
  setLoginState (state, payload) {
    state.loginState = payload
  },
  setNewUserUuid (state, payload) {
    state.newUserUuid = payload
  },
  setBreadcrumbs (state, payload) {
    state.breadcrumbs = payload
  },
  addRequestedProject (state, payload) {
    state.requestedProjects.push(payload)
  },
  resetState (state, payload) {
    state.userOrganization = []
    state.selectedOrganizationId = null
    state.selectedProjectId = null
    state.projectsDisplay = 'normal'
    state.displayOwnProjects = false
    state.loginState = 'closed'
    state.requestedProjects = []
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js